import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Image from "../Image";

export default class CommonBreadCrumb extends Component {
  lastAndTo = (index) => {
    let { pathnames } = this.props;
    if (pathnames.find((p) => p === process.env.PUBLIC_URL.split("/").pop())) {
      pathnames = pathnames.slice(1);
    }
    const last = index === pathnames.length - 1;
    const to = `/${pathnames.slice(0, index + 1).join("/")}`;
    return { last, to };
  };

  render() {
    let { hideFirst, pathnames, breadcrumbNameMap } = this.props;
    if (pathnames.find((p) => p === process.env.PUBLIC_URL.split("/").pop())) {
      pathnames = pathnames.slice(1);
    }
    return pathnames.length === 1 && !!hideFirst ? (
      <div />
    ) : (
      <Breadcrumbs
        className="Breadcrumbs-styling"
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="Breadcrumb"
      >
        {pathnames.map((value, index) => {
          const { last, to } = this.lastAndTo(index);
          return (
            <div style={{ display: "flex" }} key={index}>
              {index === 0 && (
                <Image
                  src={"/images/bajaj_web-page-home.svg"}
                  alt="web-page-home"
                  style={{ height: 20, marginRight: 10 }}
                />
              )}
              {last ? (
                <div className="transaction-summary-label">
                  {breadcrumbNameMap[to].title}
                </div>
              ) : (
                <NavLink
                  className="breadcrumbs-unselect-label"
                  to={breadcrumbNameMap[to].to}
                >
                  {breadcrumbNameMap[to].title}
                </NavLink>
              )}
            </div>
          );
        })}
      </Breadcrumbs>
    );
  }
}
